import {useStaticQuery, graphql} from "gatsby"

export const GetListEn = () => {
    const {allMdx} = useStaticQuery(
        graphql`
        query listYachtsEn {
              allMdx(filter: {fileAbsolutePath: {regex: "src/yachtsEn/"}}) {
                edges {
                  node {
                    frontmatter {
                      slug
                      title
                      velocidad
                      eslora
                      manga
                      capacidad
                      thumbnail {
                        childImageSharp {
                          fluid(maxWidth: 790) {
                                ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        `
    )
    return allMdx.edges;
}
